
import { defineComponent, computed } from 'vue'
import VisaCC from '@/assets/icons/cc-visa.svg?inline'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'CardWallet',
  components: {
    VisaCC,
  },
  setup() {
    const { currentTheme, currentMode } = useTheme()

    const gradients = computed(() => {
      const { from, to, direction } = currentTheme.value.gradients.main

      return [direction, from, to]
    })

    const cardClasses = computed(() => {
      return `${currentTheme.value.rings.bg} ring-8 ring-offset-0 ring-opacity-20 rounded-3xl`
    })

    const bgGradient = computed(() => {
      const { from, to, direction } = currentTheme.value.gradients.bg

      return [direction, from, to]
    })

    return {
      currentTheme,
      cardClasses,
      currentMode,
      bgGradient,
      gradients,
    }
  },
})
